/* Page « Votre devis » : lit le devis dans l'API ABC Garage grâce au jeton du lien (?d=…),
   l'affiche (prénom, voiture, lignes, total TVA comprise) et permet de l'accepter d'un geste.
   Aucune donnée personnelle au-delà du prénom : ni nom de famille, ni téléphone, ni adresse. */
(function () {
  var box = document.querySelector("[data-votre-devis]");
  if (!box) return;
  var etat = box.querySelector("[data-vd-etat]"), contenu = box.querySelector("[data-vd-contenu]");
  var api = (box.getAttribute("data-api") || "").replace(/\/+$/, "");
  var jeton = new URLSearchParams(location.search).get("d") || "";
  var tel = box.getAttribute("data-tel") || "", patron = box.getAttribute("data-patron") || "Le garage";
  var url = api + "/v1/public/devis/" + encodeURIComponent(jeton);

  function echapper(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  /* « 165.– », « 129.70 », « 1'250.– » : comme l'app et les factures. */
  function prix(c) {
    var neg = c < 0; c = Math.abs(Math.round(c));
    var francs = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, "'"), ct = c % 100;
    return (neg ? "-" : "") + francs + (ct === 0 ? ".–" : "." + (ct < 10 ? "0" : "") + ct);
  }
  function message(texte, erreur) {
    etat.hidden = false;
    etat.className = erreur ? "message-err" : "vd-charge";
    etat.textContent = texte;
    contenu.hidden = true;
  }
  function lire(r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, statut: r.status, j: j }; }); }
  var reseau = /Failed to fetch|NetworkError|Load failed|network/i;

  function afficher(d) {
    var h = '<p class="vd-bonjour">Bonjour ' + echapper(d.prenom) + ',</p>' +
      '<p class="vd-intro">Voici notre devis n° ' + echapper(d.numero) + (d.voiture ? ' pour votre <b>' + echapper(d.voiture) + '</b>' : '') + '.</p>' +
      '<ul class="vd-lignes" role="list">' + d.lignes.map(function (l) {
        return '<li><span>' + echapper(l.libelle) + '</span><b>CHF ' + prix(l.total) + '</b></li>';
      }).join("") + '</ul>' +
      '<p class="vd-total"><span>Total</span><b>CHF ' + prix(d.total) + '</b></p>' +
      '<p class="vd-tva">TVA 8,1 % comprise (CHF ' + prix(d.tva) + ')</p>' +
      (d.disponibilite ? '<p class="vd-dispo">Nous pouvons faire le travail ' + echapper(d.disponibilite) + '.</p>' : '');
    if (d.statut === "envoye") {
      h += '<div class="vd-accord"><button class="btn btn-elec" type="button" data-vd-accepter>J\'accepte ce devis</button>' +
        '<p class="vd-note">Vous payez au garage, une fois le travail fait : espèces, TWINT ou carte. ' + echapper(patron) + ' vous contacte pour fixer le rendez-vous.</p></div>';
    } else if (d.statut === "accepte") {
      h += '<p class="vd-ok" role="status">✓ Devis accepté, merci ! ' + echapper(patron) + ' vous contacte pour fixer le rendez-vous.</p>';
    } else if (d.statut === "paye") {
      h += '<p class="vd-ok" role="status">✓ Ce devis est réglé. Merci pour votre confiance !</p>';
    } else {
      h += '<p class="message-err">Ce devis n\'est plus valable. Appelez-nous pour un nouveau prix : ' + echapper(tel) + '.</p>';
    }
    contenu.innerHTML = h;
    contenu.hidden = false;
    etat.hidden = true;
  }

  if (!api) return message("Le suivi des devis en ligne arrive bientôt. Appelez-nous au " + tel + ".", false);
  if (!/^[A-Za-z0-9_-]{20,64}$/.test(jeton)) return message("Ce lien est incomplet. Ouvrez en entier le lien reçu sur WhatsApp, ou appelez-nous au " + tel + ".", true);

  fetch(url, { mode: "cors", credentials: "omit", cache: "no-store" })
    .then(lire)
    .then(function (res) {
      if (res.ok) return afficher(res.j);
      message(res.statut === 404
        ? "Ce devis n'existe pas ou a été modifié depuis l'envoi. Demandez le nouveau lien au garage : " + tel + "."
        : (res.j && res.j.message) || "Le devis ne peut pas s'afficher pour le moment. Réessayez dans un instant.", true);
    })
    .catch(function () { message("Impossible de charger le devis. Vérifiez votre connexion internet et réessayez, ou appelez-nous au " + tel + ".", true); });

  box.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest("[data-vd-accepter]");
    if (!b || b.disabled) return;
    var avant = b.textContent;
    b.disabled = true; b.setAttribute("aria-busy", "true"); b.textContent = "Un instant…";
    fetch(url + "/accepter", { method: "POST", mode: "cors", credentials: "omit", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: JSON.stringify({ mode: "au_garage" }) })
      .then(lire)
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.message) || "");
        afficher(res.j);
      })
      .catch(function (e) {
        b.disabled = false; b.removeAttribute("aria-busy"); b.textContent = avant;
        var p = b.parentNode.querySelector(".message-err") || b.parentNode.appendChild(document.createElement("p"));
        p.className = "message-err"; p.setAttribute("role", "alert");
        p.textContent = e && e.message && !reseau.test(e.message) ? e.message : "Connexion impossible. Réessayez, ou appelez-nous au " + tel + ".";
      });
  });
})();
